import { render, staticRenderFns } from "./DsfExamEntrance.vue?vue&type=template&id=4a72947d&"
import script from "./DsfExamEntrance.vue?vue&type=script&lang=js&"
export * from "./DsfExamEntrance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/DsfExamEntrance.vue"
export default component.exports